/**
 * @fileoverview Agent definition for template-generator-v2.
 *
 * This agent generates author or universe style templates based on a name.
 * Used by admins to create new templates for the application.
 *
 * @category meta
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'template-generator-v2',
  kind: 'primitive',
  name: 'Template Generator',
  description: 'Generates author or universe style templates for the application.',
  category: 'style',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    usedBy: ['TemplateGeneratorPage'],
    usedInComposites: [],
    relatedAgents: ['generate-custom-style-guide-v2', 'style-analyzer-v2'],
    taxonomyPath: 'meta.style.templates',
  },
};
